/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { ResourceDependencies } from '@atlassian/react-resource-router/src/common/types';

export async function consumeDependency<R = unknown>(
	dependencies: ResourceDependencies,
	key: string,
): Promise<R> {
	// There is an inflight request, the response is source of truth
	if (dependencies[key]?.loading) {
		// oxlint-disable-next-line typescript/consistent-type-assertions
		return dependencies[key]?.promise as Promise<R>;
	}

	if (dependencies[key]?.error) {
		// Our dependency errored out the last time it ran, we don't have the data
		throw dependencies[key]?.error;
	}
	// Last response is what we want
	// oxlint-disable-next-line typescript/consistent-type-assertions
	return dependencies[key]?.data as R;
}
